import { Box, Flex, Stack, Text } from '@mantine/core';
import { useSearchParams } from 'react-router-dom';

import { useGetAiAgentModelList } from '../../../../../../shared/apis/ai-agent/model/reactQueries';

import * as C from '../../../../../ui/common/CommonStyles';

import AiAgentTabs from '../../Common/ui/AiAgentTabs';
import useAiAgentModelFilters from './hooks/useAiAgentModelFilters';
import AiAgentModelFilterSection from './ui/filterSection';
import ModelListTable from './ui/modelListTable';

export default function AiAgentModel() {
  const [searchParams] = useSearchParams();
  const companyName = searchParams.get('companyName') || '';

  const {
    filterForm,
    queryParams,
    inputRef,
    updateFilterForm,
    handleSearchType,
    handleSearch,
    handlePageChange,
    resetSearchInput,
    resetFilters,
  } = useAiAgentModelFilters();

  const { data } = useGetAiAgentModelList(queryParams);

  return (
    <div>
      {/* <C.TitleBox>
        <div className="title">기계모델 관리</div>
      </C.TitleBox> */}
      <C.ListBox>
        <Stack gap="lg">
          <Flex
            gap="md"
            align="center"
            justify="space-between"
            style={(theme) => ({
              border: `1px solid ${theme.colors.gray[3]}`,
              backgroundColor: theme.colors.gray[0],
              borderRadius: theme.radius.sm,
              padding: theme.spacing.sm,
            })}
          >
            <Box>
              <Text size="xs" c="gray.6">
                거래처명
              </Text>
              <Text fw={500}>{companyName}</Text>
            </Box>
          </Flex>
          <AiAgentTabs />
          <AiAgentModelFilterSection
            filterForm={filterForm}
            inputRef={inputRef}
            onChangeFilterForm={updateFilterForm}
            onChangeSearchType={handleSearchType}
            handleSearch={handleSearch}
            resetSearchInput={resetSearchInput}
            onReset={resetFilters}
          />
          <ModelListTable
            data={data}
            page={queryParams.page ?? 1}
            size={queryParams.size ?? 10}
            onPageChange={handlePageChange}
          />
        </Stack>
      </C.ListBox>
    </div>
  );
}
